import { render, staticRenderFns } from "./UploadImages.vue?vue&type=template&id=67516e9c&scoped=true"
import script from "./UploadImages.vue?vue&type=script&lang=js"
export * from "./UploadImages.vue?vue&type=script&lang=js"
import style0 from "./UploadImages.vue?vue&type=style&index=0&id=67516e9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67516e9c",
  null
  
)

export default component.exports